import { CommentCount } from './CommentCount';
import { CommentEmbed } from './CommentEmbed';
import { DiscussionEmbed } from './DiscussionEmbed';
import { Recommendations } from './Recommendations';

export { CommentCount };
export { CommentEmbed };
export { DiscussionEmbed };
export { Recommendations };

const Disqus = {
    CommentCount,
    CommentEmbed,
    DiscussionEmbed,
    Recommendations,
};

export default Disqus;
